import React, { useState } from "react";
import "../components/SolarBanner.css";
import SOLARPLANT from "../images/videos/SOLARPLANT.mp4";

export default function SolarBanner() {

  const [showForm, setShowForm] = useState(false);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [service, setService] = useState(""); // ✅ single service

  const phone = "919597839564";

  const solarOptions = [
    "On Grid Solar Installation",
    "Off Grid Solar Installation",
    "Hybrid Solar Installation",
    "Ground Mounted Solar Power Plant",
    "Solar Carport / Canopy Installation",
    "Solar Street Light Installation",
    "Solar Water Heating",
    "Lightning Arrestor",
    "Services/AMC"
  ];

  // ✅ single-select checkbox logic
  const handleCheckbox = (value) => {
    setService(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name || !mobile || !service) {
      alert("Please fill all details and select one installation type");
      return;
    }

    const message = encodeURIComponent(
      `Hello RAD ENVIRONEX \n\n` +
      `Name: ${name}\n` +
      `Mobile: ${mobile}\n\n` +
      `Interested Solar Installation:\n` +
      `• ${service}`
    );

    window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
  };

  return (
    <>
      {/* HERO SECTION */}
      <section className="hero">
        <video
          className="hero-video"
          src={SOLARPLANT}
          autoPlay
          loop
          muted
          playsInline
        />

        <div className="hero-overlay"></div>

        <div className="hero-content">
          <div className="title-box animate-glow">
            <h1>SOLAR INSTALLATION</h1>
            <p>Power Your Future with the Sun</p>

            <button className="quote-btn" onClick={() => setShowForm(true)}>
              Get Quote
            </button>
          </div>
        </div>
      </section>

      {/* QUOTE FORM MODAL */}
      {showForm && (
        <div className="quote-modal">
          <div className="quote-form-box">
            <h2>Solar Installation Enquiry</h2>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />

              <input
                type="tel"
                placeholder="Mobile Number"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />

              <div className="checkbox-group">
                <p>Select Installation Type</p>

                <div className="checkbox-grid">
                  {solarOptions.map((item, index) => (
                    <label key={index} className="checkbox-item">
                      <input
                        type="checkbox"
                        checked={service === item}   // ✅ key fix
                        onChange={() => handleCheckbox(item)}
                      />
                      <span>{item}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="form-actions">
                <button type="submit">Send via WhatsApp</button>
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => setShowForm(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
